<template>
	<div class="row" style="padding: 30px">
		<div class="col-12" v-if="success">
			<div class="row" style="margin-top: 225px">
				<div class="col-12 center">
					<h2 class="teal-text">Success!</h2>
					<p>
						The reservation request has been registered and sent for
						approval. The consultant will be updated by E-Mail
					</p>
					<button
						@click="closeModal"
						@touchstart.prevent="closeModal"
						style="margin-top: 20px"
						class="waves-effect waves-light teal btn-small btn-block"
					>
						Sluiten
					</button>
				</div>
			</div>
		</div>
		<div class="col-12" v-if="!success">
			<div class="row">
				<div class="col-12">
					<h5>Request A Booking | {{ selectedOffice.naam }}</h5>
				</div>
			</div>
			<div class="row margin-top-20">
				<div class="col-8">
					<h5 class="teal-text">{{ day }}</h5>
					<p class="grey-text">{{ time }}</p>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<label for>Name</label>
					<input type="text" v-model="name_employee" :disabled="true" />
				</div>
			</div>
			<div class="row margin-top-30">
				<div class="col-12 occupancy-buttons">
					<div class="row center">
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 1 && !all_day }"
								@touchstart.prevent="shift = 1"
								@click.prevent="shift = 1"
								:disabled="checkPossibility(1) != 0"
							>
								<span v-if="checkPossibility(1) == 0"
									>07:00 - 08:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(1) != 0"
									>{{ getWhoBooked(1) }}</span
								>
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 2 && !all_day }"
								@touchstart.prevent="shift = 2"
								@click.prevent="shift = 2"
								:disabled="checkPossibility(2) != 0"
							>
								<span v-if="checkPossibility(2) == 0"
									>08:00 - 09:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(2) != 0"
									>{{ getWhoBooked(2) }}</span
								>
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 3 && !all_day }"
								@touchstart.prevent="shift = 3"
								@click.prevent="shift = 3"
								:disabled="checkPossibility(3) != 0"
							>
								<span v-if="checkPossibility(3) == 0"
									>09:00 - 10:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(3) != 0"
									>{{ getWhoBooked(3) }}</span
								>
							</button>
						</div>
					</div>
					<div class="row center">
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 4 && !all_day}"
								@touchstart.prevent="shift = 4"
								@click.prevent="shift = 4"
								:disabled="checkPossibility(4) != 0"
							>
								<span v-if="checkPossibility(4) == 0"
									>10:00 - 11:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(4) != 0"
									>{{ getWhoBooked(4) }}</span
								>
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 5 && !all_day }"
								@touchstart.prevent="shift = 5"
								@click.prevent="shift = 5"
								:disabled="checkPossibility(5) != 0"
							>
								<span v-if="checkPossibility(5) == 0"
									>11:00 - 12:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(5) != 0"
									>{{ getWhoBooked(5) }}</span
								>
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 6 && !all_day}"
								@touchstart.prevent="shift = 6"
								@click.prevent="shift = 6"
								:disabled="checkPossibility(6) != 0"
							>
								<span v-if="checkPossibility(6) == 0"
									>12:00 - 13:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(6) != 0"
									>{{ getWhoBooked(6) }}</span
								>
							</button>
						</div>
					</div>
					<div class="row center">
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 7 && !all_day }"
								@touchstart.prevent="shift = 7"
								@click.prevent="shift = 7"
								:disabled="checkPossibility(7) != 0"
							>
								<span v-if="checkPossibility(7) == 0"
									>13:00 - 14:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(7) != 0"
									>{{ getWhoBooked(7) }}</span
								>
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 8 && !all_day }"
								@touchstart.prevent="shift = 8"
								@click.prevent="shift = 8"
								:disabled="checkPossibility(8) != 0"
							>
								<span v-if="checkPossibility(8) == 0"
									>14:00 - 15:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(8) != 0"
									>{{ getWhoBooked(8) }}</span
								>
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 9 && !all_day }"
								@touchstart.prevent="shift = 9"
								@click.prevent="shift = 9"
								:disabled="checkPossibility(9) != 0"
							>
								<span v-if="checkPossibility(9) == 0"
									>15:00 - 16:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(9) != 0"
									>{{ getWhoBooked(9) }}</span
								>
							</button>
						</div>
					</div>
					<div class="row center">
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 10 && !all_day }"
								@touchstart.prevent="shift = 10"
								@click.prevent="shift = 10"
								:disabled="checkPossibility(10) != 0"
							>
								<span v-if="checkPossibility(10) == 0"
									>16:00 - 17:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(10) != 0"
									>{{ getWhoBooked(10) }}</span
								>
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 11 && !all_day }"
								@touchstart.prevent="shift = 11"
								@click.prevent="shift = 11"
								:disabled="checkPossibility(11) != 0"
							>
								<span v-if="checkPossibility(11) == 0"
									>17:00 - 18:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(11) != 0"
									>{{ getWhoBooked(11) }}</span
								>
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block booking-button"
								:class="{ grey: shift != 12 && !all_day }"
								@touchstart.prevent="shift = 12"
								@click.prevent="shift = 12"
								:disabled="checkPossibility(12) != 0"
							>
								<span v-if="checkPossibility(12) == 0"
									>18:00 - 19:00</span
								>
								<span
									class="booker-name"
									v-if="checkPossibility(12) != 0"
									>{{ getWhoBooked(12) }}</span
								>
							</button>
						</div>
					</div>

                    <div class="col m12">
                        <button
                            type="button"
                            class="waves-effect waves-light btn btn-block booking-button"
                            :class="{ grey: !all_day }"
                            :disabled="shift"	
                            @click="all_day = !all_day"
                        >
                            <span>All Available Timeslots</span>
                        </button>
                    </div>

				</div>
			</div>
		</div>

		<div class="row" v-if="!success && permission > 100">
			<div class="col-12 input-field">
				<textarea
					style="height: 90px"
					v-model="why"
					class="materialize-textarea"
					id="text-area-why"
					maxlength="200"
				></textarea>
				<label for="text-area-why">Who will be present?</label>
			</div>
		</div>

		<!-- <div class="row margin-top-20" v-if="!success && permission > 100">
			<div class="col m6">
				<button
					type="button"
					class="waves-effect waves-light btn btn-block booking-button"
					:class="{ grey: !multiple }"
					@touchstart.prevent="!shift"
					:disabled="!shift"
					@click="multiple = !multiple"
				>
					<span>Returning booking?</span>
				</button>
			</div>
		</div>

        <div class="row margin-top-20" v-if="!success && multiple && permission > 100">
			<div class="col m6">
				<button
					type="button"
					class="waves-effect waves-light btn btn-block booking-button"
					:class="{ grey: number_returning_days == 7 }"
					@touchstart.prevent="!shift"
					:disabled="!shift"
					@click="number_returning_days = 1"
				>
					<span>Daily</span>
				</button>
			</div>
            <div class="col m6">
				<button
					type="button"
					class="waves-effect waves-light btn btn-block booking-button"
					:class="{ grey: number_returning_days == 1 }"
					@touchstart.prevent="!shift"
					:disabled="!shift"
					@click="number_returning_days = 7"
				>
					<span>Weekly</span>
				</button>
			</div>
            <div class="col m6 margin-top-20">
                <label for="number_bookings">Number of occurences</label>
                <input id="number_bookings" type="number" v-model="number_of_bookings" :disabled="!multiple" min="0" max="52" step="1" @input="number_of_bookings = Math.ceil(number_of_bookings)" />
            </div>
		</div> -->

		<div class="row margin-top-30" v-if="!success">
			<div class="col-12">
				<button
					type="button"
					style="width: 100% !important"
					:disabled="(!shift && !all_day) || (permission > 100 && !why) || (shift && multiple && (!number_of_bookings || number_of_bookings < 1 || number_of_bookings > 52))"
					class="waves-effect waves-light btn"
					@touchstart.prevent="confirmBooking()"
					@click.prevent="confirmBooking()"
				>
					Confirm Reservation
				</button>
			</div>
		</div>
		<div class="row" v-if="feedback">
			<div class="col-12">
				<p class="red-text">{{ feedback }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import checkAvailability from "@/components/modals/checkAvailability";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import firebase from "firebase";
export default {
	name: "checkAvailability",
	data() {
		return {
			name_employee: null,
			email_employee: null,
			shift: null,
			disabled_day: false,
			disabled_afternoon: false,
			disabled_morning: false,
			time: null,
			day: null,
            date_string: null,
            number_returning_days: 7,
            number_of_bookings: 2,
			feedback: null,
            permission: 100,
			multiple: false,
            all_day: false,
			success: false,
			user: null,
			why: null,
			external: false,
		};
	},
	props: ["office_id", "timestamp", "shifts_possible"],
	computed: {
		...mapGetters([
			"selectedOffice",
			"officeTimestampBookings",
			"myTimestampBookings",
		]),
	},
	methods: {
		...mapActions([
			"createTimeSlotBooking",
			"setOfficeTimestampBookings",
			"setMyTimestampBookings",
		]),
        generateRandomId(length) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return result;
        },
		confirmBooking() {
			if (this.name_employee) {

                var randomIdString = this.generateRandomId(8)

                if(this.multiple){

                } else if(this.all_day) {

                    var something_booked = false;

                    for (let i = 1; i <= 12; i++) {

                        if(this.checkPossibility(i) == 0 || this.checkPossibility(i) == 4) {

                            let info = {
                                officeid: this.office_id,
                                employee: this.name_employee,
                                timestamp: this.timestamp,
                                location: this.selectedOffice.naam,
                                shift: i,
                                why: this.why,
                                all_day: true,
                                date_string: this.date_string,
                                groupID: randomIdString,
                            };

                            this.createTimeSlotBooking(info);

                            console.log("Timeslot " + i + " is available and booked.");
                            something_booked = true;

                        } else {

                            console.log("Timeslot " + i + " is not available.");
                        
                        }

                    }

                    if(something_booked) {
                        this.success = true;
                    } else {
                        this.feedback = "All timeslots were already booked.";
                    }

                } else {

                    if(this.shift) {
         
                        let info = {
                            officeid: this.office_id,
                            employee: this.name_employee,
                            timestamp: this.timestamp,
                            location: this.selectedOffice.naam,
                            shift: this.shift,
                            why: this.why,
                            all_day: false,
                            date_string: this.date_string,
                            groupID: randomIdString,
                        };

                        this.createTimeSlotBooking(info);

                        this.success = true;

                    } else {
                            
                        this.feedback = "You must select a timeslot.";

                    }


                }

			} else {

				this.feedback = "You must provide a name.";

			}
		},
		checkPossibility(shift) {
			var length_user = this.myTimestampBookings.filter(
				(x) => x.shift == shift
			);
			var length_office = this.officeTimestampBookings.filter(
				(x) => x.shift == shift
			);
			var caroline_blocked = length_office.findIndex(
				(x) =>
					x.email == "rutger.beerens@pnoconsultants.com" ||
					x.email == "c.spel@burdock.com"
			);
			if (caroline_blocked > -1) {
				console.log("Caroline Blocked");
				return 3;
			} else if (length_user.length > 0) {
				return 2;
			} else if (length_office.length >= this.selectedOffice.plekken) {
				return 1;
			} else if (this.all_day) {
                return 4;
            } else {
				return 0;
			}
		},
		truncateString(str, maxLength) {
			if (str.length > maxLength) {
				return str.substring(0, maxLength) + "...";
			}

			return str;
		},
		getWhoBooked(shift) {
			console.log("Getting who booked shift: " + shift);
			var bookings = this.officeTimestampBookings.filter(
				(x) => x.shift == shift
			);
			console.log(bookings);
			if (bookings.length > 0) {
				return this.truncateString(bookings[0].employee, 18);
			} else {
				return "";
			}
		},
		closeModal() {
			this.$emit("close");
		},
	},
	async created() {
		console.log(this.timestamp);
		await this.setOfficeTimestampBookings({
			officeid: this.$route.params.officeid,
			timestamp: this.timestamp,
		});
		await this.setMyTimestampBookings({ timestamp: this.timestamp });
		console.log(this.myTimestampBookings);
		console.log(this.officeTimestampBookings);
		console.log(this.selectedOffice);
		this.time = moment(this.timestamp).format("Do MMM");
		this.day = moment(this.timestamp).format("dddd");
        this.date_string = moment(this.timestamp).format("DD-MM-YYYY");
		this.user = firebase.auth().currentUser;
		this.name_employee = this.user.displayName;
		console.log(this.user);
        this.permission = Number(this.user.permission);
	},
};
</script>

<style>
.occupancy-buttons .md4 {
	padding-left: 3px;
	padding-right: 3px;
}

.booking-button {
	width: 100% !important;
	padding-left: 0.3rem !important;
	padding-right: 0.3rem !important;
	font-size: 1rem !important;
}

.booker-name {
	font-size: 0.7rem !important;
}
</style>


// WEBPACK FOOTER //
// src/components/modals/checkAvailability.vue